export default __webpack_public_path__ + "static/media/deRisk.7894741a.svg";